import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ExpenseImmobilier, ExpenseType, PaymentMethod, PaymentStatus } from '../../models/expense-immobilier';
import { ImmobilierService } from '../../services/immobilier.service';

@Component({
    selector: 'app-add-edit-expense-dialog',
    templateUrl: './add-edit-expense-dialog.component.html',
    styleUrls: ['./add-edit-expense-dialog.component.css']
})
export class AddEditExpenseDialogComponent implements OnInit {

    expense: ExpenseImmobilier;
    isNew: boolean = true;
    properties: any[] = [];

    // Dropdown options
    expenseTypes: ExpenseType[] = [
        'maintenance', 'taxe', 'assurance', 'charges', 'amenagement', 'foncier', 'copropriete', 'syndic', 'autre'
    ];

    paymentMethods: PaymentMethod[] = [
        'virement', 'cheque', 'especes', 'carte', 'prelevement', 'autre'
    ];

    paymentStatuses: PaymentStatus[] = [
        'non_paye', 'partiel', 'paye', 'en_retard'
    ];

    // Custom Stepper
    currentStep = 0;
    steps: string[] = [
        'Informations Générales',
        'Montants & Dates',
        'Paiement & Fournisseur'
    ];

    constructor(
        public dialogRef: MatDialogRef<AddEditExpenseDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private immobilierService: ImmobilierService,
        private snackBar: MatSnackBar
    ) {
        if (data && data.expense) {
            this.expense = { ...data.expense };
            this.isNew = false;
        } else {
            this.isNew = true;
            this.expense = {
                id: 0,
                reference: this.generateReference(),
                propertyId: 0,
                type: 'maintenance',
                category: '',
                title: '',
                description: '',
                amount: 0,
                taxAmount: 0,
                totalAmount: 0,
                expenseDate: new Date(),
                paymentStatus: 'non_paye',
                isRecoverable: false,
                createdAt: new Date(),
                updatedAt: new Date()
            };
        }
    }

    ngOnInit(): void {
        this.loadProperties();
    }

    loadProperties(): void {
        this.immobilierService.getProperties().subscribe({
            next: (properties) => {
                this.properties = properties;
            }
        });
    }

    generateReference(): string {
        const date = new Date();
        const year = date.getFullYear();
        let random = Math.floor(Math.random() * 1000).toString();
        while (random.length < 3) {
            random = '0' + random;
        }
        return `EXP-${year}-${random}`;
    }

    calculateTotal(): void {
        const amount = this.expense.amount || 0;
        const tax = this.expense.taxAmount || 0;
        this.expense.totalAmount = amount + tax;
    }

    // Stepper Navigation
    nextStep(): void {
        if (this.currentStep < this.steps.length - 1) {
            this.currentStep++;
        }
    }

    prevStep(): void {
        if (this.currentStep > 0) {
            this.currentStep--;
        }
    }

    setStep(index: number): void {
        this.currentStep = index;
    }

    save(): void {
        // Update property info based on selection
        const selectedProperty = this.properties.find(p => p.id === this.expense.propertyId);
        if (selectedProperty) {
            this.expense.propertyReference = selectedProperty.reference;
            this.expense.propertyTitle = selectedProperty.title;
        }

        if (this.isNew) {
            this.immobilierService.createExpense(this.expense).subscribe({
                next: (res) => {
                    this.snackBar.open('Dépense ajoutée avec succès', 'Fermer', { duration: 3000 });
                    this.dialogRef.close(res);
                },
                error: (err) => {
                    console.error(err);
                    this.snackBar.open('Erreur lors de l\'ajout', 'Fermer', { duration: 3000 });
                }
            });
        } else {
            this.immobilierService.updateExpense(this.expense.id, this.expense).subscribe({
                next: (res) => {
                    this.snackBar.open('Dépense modifiée avec succès', 'Fermer', { duration: 3000 });
                    this.dialogRef.close(res);
                },
                error: (err) => {
                    console.error(err);
                    this.snackBar.open('Erreur lors de la modification', 'Fermer', { duration: 3000 });
                }
            });
        }
    }

    cancel(): void {
        this.dialogRef.close();
    }
}
